<template>
    <div v-if="image && image.path" class="aspect-[16/4] w-full overflow-hidden bg-gray-50">
        <NuxtImg
            class="w-full overflow-hidden rounded mix-blend-multiply"
            :class="!cloudflareImages ? 'h-full object-cover' : 'h-auto object-contain'"
            :placeholder="img(image.path, { h: 50, w: 200, fit: 'cover' })"
            :src="image.path"
            loading="lazy"
            fit="cover"
            width="800"
            height="200"
        />
    </div>
</template>

<script setup>
    defineProps({
        image: {
            type: [ Object ]
        }
    })
    const { public: { cloudflareImages } } = useRuntimeConfig()
    const img = useImage()
</script>
